// src/utils/priceUtils.js
import Papa from "papaparse";
import { debugLogger } from "./LogDebug";
// import logErrorToServer from "./logErrorToServer";

// const fileRSPrices = process.env.REACT_APP_FILE_RS_PRICES || "/proxy/rs_transports/rs_prix.csv";
// const fileRSPrices = "/prices/rs_prix.csv";
// const fileRSPrices = `${process.env.PUBLIC_URL}/prices/rs_prix.csv`;
const fileRSPrices = "/data/rs_prix.csv"; // Chemin relatif à public/

console.log("fileRSPrices="+fileRSPrices);
debugLogger.log("fileRSPrices="+fileRSPrices);
export const fetchPrices = async () => {
    try {
        // logErrorToServer("fetch(fileRSPrices)" + fileRSPrices);
        // const response = await fetch(fileRSPrices);


        console.log("Fetching:", fileRSPrices);
        debugLogger.log({"Fetching": fileRSPrices});
        
        const response = await fetch(fileRSPrices);
        // const response = await fetch("/data/shuttlePrices.csv");

        if (!response.ok) {
            // logErrorToServer("HTTP error! status" + response.status);
            throw new Error(`HTTP error! status: ${response.status}`);
        }
        const csvText = await response.text();
        const data = Papa.parse(csvText, {
            delimiter: ";",
            header: true,
            skipEmptyLines: true,
        }).data;

        if (!data || !Array.isArray(data)) {
            // logErrorToServer("Invalid CSV data");
            throw new Error('Invalid CSV data');
        }
/*
shuttle	Depart	Arrive	aller_retour	mode_paiement	price1	price2	price3	price4	price5	price6	price7	price8	price22	price_sup	depart_type	arrive_type	duree_aller	duree_retour	delai_depart	delai_arrive	id	cp_possible_depart	cp_possible_arrive
0	BEAUVAIS AIRPORT	DISNEYLAND	1	1	7100	8100	9100	10100	12100	13000	13500	15000	9900	2300	1	2	95	95	30	130	45		77700 DISNEYLAND,77700 COUPVRAY,77700 MAGNY LE HONGRE,77700 SERRIS,77700 BAILLY ROMAINE VILLIERS,77144 MONTERVRAINE,77700 CHESSY,77600 BUSSY ST GEORGE,77144 MONTERVRAIN,77700 MAGNY LE HONGRE,77200 TORCY
0	BEAUVAIS AIRPORT	DISNEYLAND	2	1	14000	16000	18000	20000	24000	25800	26800	29800	19600	4500	1	2	95	95	30	130	47		77700 DISNEYLAND,77700 COUPVRAY,77700 MAGNY LE HONGRE,77700 SERRIS,77700 BAILLY ROMAINE VILLIERS,77144 MONTERVRAINE,77700 CHESSY,77600 BUSSY ST GEORGE,77144 MONTERVRAIN,77700 MAGNY LE HONGRE,77200 TORCY
0	BEAUVAIS AIRPORT	DISNEYLAND	3	1	7100	8100	9100	10100	12100	13000	13500	15000	9900	2300	1	2	95	95	30	130	46		77700 DISNEYLAND,77700 COUPVRAY,77700 MAGNY LE HONGRE,77700 SERRIS,77700 BAILLY ROMAINE VILLIERS,77144 MONTERVRAINE,77700 CHESSY,77600 BUSSY ST GEORGE,77144 MONTERVRAIN,77700 MAGNY LE HONGRE,77200 TORCY
private	Depart	Arrive	aller_retour	mode_paiement	nb_pax_mini	nb_pax_maxi	prix	depart_type	arrive_type	duree_aller	duree_retour	delai_depart	delai_arrive	id	cp_possible_depart	cp_possible_arrive		45	30	135	4		77700 DISNEYLAND,77700 COUPVRAY,77700 MAGNY LE HONGRE,77700 SERRIS,77700 BAILLY ROMAINE VILLIERS,77144 MONTERVRAINE,77700 CHESSY,77600 BUSSY ST GEORGE,77144 MONTERVRAIN,77700 MAGNY LE HONGRE,77200 TORCY
1	BEAUVAIS AIRPORT	DISNEYLAND	1	1	1	2	11500.00	1	2	75	75	30	135	43		77700 DISNEYLAND,77700 COUPVRAY,77700 MAGNY LE HONGRE,77700 SERRIS,77700 BAILLY ROMAINE VILLIERS,77144 MONTERVRAINE,77700 CHESSY,77600 BUSSY ST GEORGE,77144 MONTERVRAIN,77700 MAGNY LE HONGRE,77200 TORCY
1	BEAUVAIS AIRPORT	DISNEYLAND	1	1	3	3	12500.00	1	2	75	75	30	135	44		77700 DISNEYLAND,77700 COUPVRAY,77700 MAGNY LE HONGRE,77700 SERRIS,77700 BAILLY ROMAINE VILLIERS,77144 MONTERVRAINE,77700 CHESSY,77600 BUSSY ST GEORGE,77144 MONTERVRAIN,77700 MAGNY LE HONGRE,77200 TORCY
1	BEAUVAIS AIRPORT	DISNEYLAND	1	1	4	4	13000.00	1	2	75	75	30	135	45		77700 DISNEYLAND,77700 COUPVRAY,77700 MAGNY LE HONGRE,77700 SERRIS,77700 BAILLY ROMAINE VILLIERS,77144 MONTERVRAINE,77700 CHESSY,77600 BUSSY ST GEORGE,77144 MONTERVRAIN,77700 MAGNY LE HONGRE,77200 TORCY
*/
        // Séparer les données entre Shuttle et Private
        const shuttles = data
            .filter((row) => row.shuttle === "0")
            .map((row) => {
                const shuttleObj = {
                    type: "Shuttle",
                    duree_aller: parseInt(row.duree_aller),
                    duree_retour: parseInt(row.duree_retour),
                    delai_depart: parseInt(row.delai_depart),
                    delai_arrive: parseInt(row.delai_arrive),
                    depart_type: parseInt(row.depart_type),
                    arrive_type: parseInt(row.arrive_type),
                    Depart: row.Depart,
                    Arrive: row.Arrive,
                    aller_retour: row.aller_retour,
                    mode_paiement: row.mode_paiement,
                    price22: (parseFloat(row.price22) / 100).toFixed(2),
                    price_sup: (parseFloat(row.price_sup) / 100).toFixed(2),
                    cp_depart: row.cp_possible_depart ? row.cp_possible_depart.split(",") : [],
                    cp_arrive: row.cp_possible_arrive ? row.cp_possible_arrive.split(",") : [],
                };

                // Ajouter les prix par nombre de passagers directement dans l'objet
                [...Array(8).keys()].forEach((pax) => {
                    const priceKey = `price${pax + 1}`;
                    if (row[priceKey]) {
                        shuttleObj[priceKey] = (parseFloat(row[priceKey]) / 100).toFixed(2);
                    }
                });

                return shuttleObj;
            });

// shuttle	Depart	Arrive	aller_retour	mode_paiement	price1	price2	price3	price4	price5	price6	price7	price8	price22	price_sup	depart_type	arrive_type	duree_aller	duree_retour	delai_depart	delai_arrive	id	cp_possible_depart	cp_possible_arrive
// 0	BEAUVAIS AIRPORT	DISNEYLAND	3	1	7100	8100	9100	10100	12100	13000	13500	15000	9900	2300	1	2	95	95	30	130	46		77700 DISNEYLAND,77700 COUPVRAY,77700 MAGNY LE HONGRE,77700 SERRIS,77700 BAILLY ROMAINE VILLIERS,77144 MONTERVRAINE,77700 CHESSY,77600 BUSSY ST GEORGE,77144 MONTERVRAIN,77700 MAGNY LE HONGRE,77200 TORCY
// private	Depart	Arrive	aller_retour	mode_paiement	nb_pax_mini	nb_pax_maxi	prix	depart_type	arrive_type	duree_aller	duree_retour	delai_depart	delai_arrive	id	cp_possible_depart	cp_possible_arrive		45	30	135	4		77700 DISNEYLAND,77700 COUPVRAY,77700 MAGNY LE HONGRE,77700 SERRIS,77700 BAILLY ROMAINE VILLIERS,77144 MONTERVRAINE,77700 CHESSY,77600 BUSSY ST GEORGE,77144 MONTERVRAIN,77700 MAGNY LE HONGRE,77200 TORCY
// 1	BEAUVAIS AIRPORT	DISNEYLAND	1	1	1	2	11500.00	1	2	75	75	30	135	43		77700 DISNEYLAND,77700 COUPVRAY,77700 MAGNY LE HONGRE,77700 SERRIS,77700 BAILLY ROMAINE VILLIERS,77144 MONTERVRAINE,77700 CHESSY,77600 BUSSY ST GEORGE,77144 MONTERVRAIN,77700 MAGNY LE HONGRE,77200 TORCY
            
        const privates = data
            .filter((row) => row.shuttle === "1")
            .map((row) => ({
                type: "Private",
                depart_type: parseInt(row.price4),
                arrive_type: parseInt(row.price5),
                duree_aller: parseInt(row.price6),
                duree_retour: parseInt(row.price7),
                delai_depart: parseInt(row.price8),
                delai_arrive: parseInt(row.price22),
                Depart: row.Depart,
                Arrive: row.Arrive,
                aller_retour: row.aller_retour,
                mode_paiement: row.mode_paiement,
                nb_pax_mini: parseInt(row.price1, 10),
                nb_pax_maxi: parseInt(row.price2, 10),
                prix: (parseFloat(row.price3) / 100).toFixed(2),
                cp_depart: row.depart_type ? row.depart_type.split(",") : [], // Correspond à la colonne cp_depart des PRIVATES
                cp_arrive: row.arrive_type ? row.arrive_type.split(",") : [], // Correspond à la colonne cp_arrive des PRIVATES
            }));

        return { shuttles, privates };
    } catch (error) {
        console.error("Error fetching CSV dans Price :", fileRSPrices, error);
        throw error;
    }
};



export const calculateShuttlePrices = (shuttleData, selectedDepart, selectedArrive) => {
    const relevantData = shuttleData.filter(
        (row) =>
            (row.Depart === selectedDepart && row.Arrive === selectedArrive) ||
            (row.Arrive === selectedDepart && row.Depart === selectedArrive)
    );

    const priceObj = {};
    relevantData.forEach((row) => {
        for (let pax = 1; pax <= 8; pax++) {
            const nbPax = `shuttle_pax_${pax}_${row.aller_retour}`;
            const newPrice = row[`price${pax}`];
            if (priceObj[nbPax] === undefined || parseFloat(priceObj[nbPax]) > parseFloat(newPrice)) {
                priceObj[nbPax] = newPrice;
            }
        }

        const indexPrice22 = `shuttle_pax_22_${row.aller_retour}`;
        const price22 = row[indexPrice22];
        if (priceObj[indexPrice22] === undefined || priceObj[indexPrice22] > price22) {
            priceObj[indexPrice22] = row.price22;
        }

        const indexPriceSup = `shuttle_pax_sup_${row.aller_retour}`;
        const priceSup = row.price_sup;
        if (priceObj[indexPriceSup] === undefined || priceObj[indexPriceSup] > priceSup) {
            priceObj[indexPriceSup] = priceSup;
        }


        // Appliquer les valeurs (inversées si nécessaire)
        const reverseTrajet = row.Arrive === selectedDepart && row.Depart === selectedArrive;

        Object.assign(priceObj, {
            duree_aller: reverseTrajet ? row.duree_retour : row.duree_aller,
            duree_retour: reverseTrajet ? row.duree_aller : row.duree_retour,
            delai_arrive: reverseTrajet ? row.delai_depart : row.delai_arrive,
            delai_depart: reverseTrajet ? row.delai_arrive : row.delai_depart,
            depart_type: reverseTrajet ? row.arrive_type : row.depart_type,
            arrive_type: reverseTrajet ? row.depart_type : row.arrive_type,
            cp_arrive: reverseTrajet ? row.cp_depart : row.cp_arrive,
            cp_depart: reverseTrajet ? row.cp_arrive : row.cp_depart,
        });

        
        
    });
    debugLogger.log("ICI ON CHARGE priceObj  "+selectedDepart+" vers "+selectedArrive);
    return priceObj;
};

export const calculatePrivatePrices = (privateData, selectedDepart, selectedArrive) => {
    const relevantData = privateData.filter(
        (row) =>
            (row.Depart === selectedDepart && row.Arrive === selectedArrive) ||
            (row.Arrive === selectedDepart && row.Depart === selectedArrive)
        );

    const priceObj = {};
    relevantData.forEach((row) => {
        if (row.nb_pax_mini >= 1 && row.nb_pax_maxi <= 8) {
            for (let pax = row.nb_pax_mini; pax <= row.nb_pax_maxi; pax++) {
                const nbPax = `private_pax_${pax}_${row.aller_retour}`;
                const newPrice = row.prix;
                if(
                    priceObj[nbPax] === undefined || // Si aucune valeur n'est définie
                    parseFloat(priceObj[nbPax]) > parseFloat(newPrice) // Comparer avec l'ancienne valeur
                )
                {
                    priceObj[nbPax] = newPrice; // Mettre à jour avec la plus basse valeur
                }
            }
        }

        // Appliquer les valeurs (inversées si nécessaire)
        const reverseTrajet = row.Arrive === selectedDepart && row.Depart === selectedArrive;

        Object.assign(priceObj, {
            duree_aller: reverseTrajet ? row.duree_retour : row.duree_aller,
            duree_retour: reverseTrajet ? row.duree_aller : row.duree_retour,
            delai_arrive: reverseTrajet ? row.delai_depart : row.delai_arrive,
            delai_depart: reverseTrajet ? row.delai_arrive : row.delai_depart,
            depart_type: reverseTrajet ? row.arrive_type : row.depart_type,
            arrive_type: reverseTrajet ? row.depart_type : row.arrive_type,
            cp_arrive: reverseTrajet ? row.cp_depart : row.cp_arrive,
            cp_depart: reverseTrajet ? row.cp_arrive : row.cp_depart,
        });

    });


    // de 1 à 8
    // si le prix 3 n'existe pas
    // lui affecter le prix 1
    // Ou le moins cher
    [...Array(8).keys()].forEach((i) => {
        const nbPax = i + 1;
        const indexReturn = `private_pax_${nbPax}_3`;
        const indexOneWay = `private_pax_${nbPax}_1`;

            // Si le prix retour n'existe pas, le définir comme étant le prix aller (s'il existe)
        if (priceObj[indexReturn] === undefined && priceObj[indexOneWay] !== undefined) {
            priceObj[indexReturn] = priceObj[indexOneWay];
        }

        // Sinon, définir le prix retour comme le moins cher entre le prix actuel et le prix aller
        if (priceObj[indexReturn] !== undefined && priceObj[indexOneWay] !== undefined) {
            priceObj[indexReturn] = Math.min(priceObj[indexReturn], priceObj[indexOneWay]).toFixed(2); // Retour en float avec deux décimales
        }
    });




    return priceObj;
};



export const calculateShuttlePricesPax = (shuttleData, selectedDepart, selectedArrive, nb_pax, nb_trajet) => {
//  console.log('calculateShuttlePricesPax', shuttleData, selectedDepart, selectedArrive, nb_pax, nb_trajet);
    let relevantData = {};
    if(nb_trajet === 2) {
        relevantData = shuttleData.filter(
            (row) =>
                (parseInt(row.aller_retour) === 2) &&
                ((row.Depart === selectedDepart && row.Arrive === selectedArrive) ||
                (row.Arrive === selectedDepart && row.Depart === selectedArrive))
        );

    } else {
        relevantData = shuttleData.filter(
            (row) =>
                (parseInt(row.aller_retour) !== 2) &&
                ((row.Depart === selectedDepart && row.Arrive === selectedArrive) ||
                (row.Arrive === selectedDepart && row.Depart === selectedArrive))
        );
    }

    const pricePax = {
        from: selectedDepart,
        to: selectedArrive,
        pax: nb_pax.total,
        cb: 0,
        cash: 0,
        duree_aller: 45,
        duree_retour: 45,
        delai_depart: 30,
        delai_arrive: 135,
        depart_type: 0,
        arrive_type: 0,
        cp_depart: null,
        cp_arrive: null,

    };
//  console.log('relevantData', relevantData);
    relevantData.forEach((row) => {
// console.log('row',row);

// console.log('aller_retour=',row.aller_retour,(row.mode_paiement === "1" ? 'cash' : 'cb'));

        if(row.mode_paiement === "1")
            pricePax.cash = calculPriceShuttle(row, nb_pax);
        else
            pricePax.cb = calculPriceShuttle(row, nb_pax);
    
        // Appliquer les valeurs (inversées si nécessaire)
        const reverseTrajet = row.Arrive === selectedDepart && row.Depart === selectedArrive;

        Object.assign(pricePax, {
            duree_aller: reverseTrajet ? row.duree_retour : row.duree_aller,
            duree_retour: reverseTrajet ? row.duree_aller : row.duree_retour,
            delai_arrive: reverseTrajet ? row.delai_depart : row.delai_arrive,
            delai_depart: reverseTrajet ? row.delai_arrive : row.delai_depart,
            depart_type: reverseTrajet ? row.arrive_type : row.depart_type,
            arrive_type: reverseTrajet ? row.depart_type : row.arrive_type,
            cp_arrive: reverseTrajet ? row.cp_depart : row.cp_arrive,
            cp_depart: reverseTrajet ? row.cp_arrive : row.cp_depart,
        });

    });

    return pricePax;
};

export const calculatePrivatePricesPax = (privateData, selectedDepart, selectedArrive, nb_pax, nb_trajet) => {
// console.log('calculatePrivatePricesPax', privateData, selectedDepart, selectedArrive, nb_pax, nb_trajet);
    if(nb_pax.total > 8)
        return calculatePrivatePricesPaxSup(privateData, selectedDepart, selectedArrive, nb_pax, nb_trajet);

    let relevantData = {};
    if(nb_trajet === 2) {
        relevantData = privateData.filter(
            (row) =>
                (parseInt(row.aller_retour) === 2) &&
                ((row.Depart === selectedDepart && row.Arrive === selectedArrive) ||
                (row.Arrive === selectedDepart && row.Depart === selectedArrive))
        );

    } else {
        relevantData = privateData.filter(
            (row) =>
                (parseInt(row.aller_retour) !== 2) &&
                ((row.Depart === selectedDepart && row.Arrive === selectedArrive) ||
                (row.Arrive === selectedDepart && row.Depart === selectedArrive))
        );
    }

    const pricePax = {
        from: selectedDepart,
        to: selectedArrive,
        pax: nb_pax.total,
        cb: 0,
        cash: 0,        
        duree_aller: 45,
        duree_retour: 45,
        delai_depart: 30,
        delai_arrive: 135,
        depart_type: 0,
        arrive_type: 0,
        cp_depart: null,
        cp_arrive: null,

    };
// console.log('relevantData', relevantData);
    relevantData.forEach((row) => {
        if (row.nb_pax_mini <= nb_pax.total && nb_pax.total <= row.nb_pax_maxi) {
            console.log('row',row.nb_pax_mini,row.nb_pax_maxi,(row.mode_paiement === "1" ? 'cash' : 'cb'));

            if(row.mode_paiement === "1")
                pricePax.cash = parseFloat(row.prix).toFixed(2);
            else
                pricePax.cb = parseFloat(row.prix).toFixed(2);


            // Appliquer les valeurs (inversées si nécessaire)
            const reverseTrajet = row.Arrive === selectedDepart && row.Depart === selectedArrive;

            Object.assign(pricePax, {
                duree_aller: reverseTrajet ? row.duree_retour : row.duree_aller,
                duree_retour: reverseTrajet ? row.duree_aller : row.duree_retour,
                delai_arrive: reverseTrajet ? row.delai_depart : row.delai_arrive,
                delai_depart: reverseTrajet ? row.delai_arrive : row.delai_depart,
                depart_type: reverseTrajet ? row.arrive_type : row.depart_type,
                arrive_type: reverseTrajet ? row.depart_type : row.arrive_type,
                cp_arrive: reverseTrajet ? row.cp_depart : row.cp_arrive,
                cp_depart: reverseTrajet ? row.cp_arrive : row.cp_depart,
            });

        }
        // console.log('aller_retour=',row.aller_retour,);
// console.log('pricePax', pricePax);
    });





    return pricePax;
};

const isSpecialCase = (adults, children, babies) => {
    return (
        (adults === 2 && children === 0 && babies === 2) ||
        (adults === 2 && children === 1 && babies === 1) ||
        (adults === 2 && children === 2 && babies === 0) || // Cas initial

        (adults === 1 && children === 0 && babies === 3) ||
        (adults === 1 && children === 1 && babies === 2) ||
        (adults === 1 && children === 2 && babies === 1) ||
        (adults === 1 && children === 3 && babies === 0)
    );
};

export const calculPriceShuttle = (row, nb_pax) => {


    let Price = row[`price${nb_pax.total}`] || 0; // Cas général
    // let listePrice = ' 2+2 =' + row.price22 + '| sup =' + row.price_sup + '|';
    // for (let index = 1; index <= 8; index++) {
    //     listePrice = listePrice + '|' + index + ' = ' + row[`price${index}`];
    // }
// console.log(nb_pax);
    const adults = parseInt(nb_pax.adults);
    const children = parseInt(nb_pax.children);
    const babies = parseInt(nb_pax.babies);

    if (isSpecialCase(adults, children, babies)) {
        Price = row.price22 ?? row.price4; // Cas du 2 + 2
        // console.log('  OK POUR  2+2 Price = ', Price);
    } else if (nb_pax.total > 8) {
        // Price = Math.parseFloat(row.price8) + Math.parseFloat(row.price_sup) * (nb_pax.total - 8);
        // console.log('    sup ', nb_pax.total - 8, 'Price = ', Price);
        // Vérifiez que row.price8 et row.price_sup sont définis et sont des nombres valides
        if (row.price8 !== undefined && row.price_sup !== undefined) {
            const price8 = parseFloat(row.price8);
            const priceSup = parseFloat(row.price_sup);

            if (!isNaN(price8) && !isNaN(priceSup)) {
                Price = price8 + priceSup * (nb_pax.total - 8);
                // console.log(' OK POUR SUP ', nb_pax.total - 8, 'Price = ', Price);
            } else {
                console.error('Invalid price8 or price_sup values:', row.price8, row.price_sup);
            }
        } else {
            console.error('price8 or price_sup is undefined:', row.price8, row.price_sup);
        }

    } else if (nb_pax.total > 0) {
        Price = row[`price${nb_pax.total}`] || 0; // Cas général
        // console.log(' OK Classique ',nb_pax.total,' let Price = ', Price);
    }
    return parseFloat(Price).toFixed(2);
};

export const calculatePrivatePricesPaxSup = (privateData, selectedDepart, selectedArrive, nb_pax, nb_trajet) => {

    const pricePax = {
        from: selectedDepart,
        to: selectedArrive,
        pax: nb_pax.total,
        cb: 0,
        cash: 0,        
        duree_aller: 45,
        duree_retour: 45,
        delai_depart: 30,
        delai_arrive: 135,
        depart_type: 0,
        arrive_type: 0,
        cp_arrive: null,
        cp_depart: null,
    };

    if(nb_pax.total > 8)
    {
        // Calculate the number of additional cabs required
        const nbCab = Math.floor(nb_pax.total / 8); // Number of full cabs
        const nbPaxSup = nb_pax.total % 8; // Passengers left for the last cab

        // Calculate price for full cabs and remaining passengers
        const nb_paxCabComplete = {adults:8, children:0, babies:0, total:8};
        const priceCab = calculatePrivatePricesPax(privateData, selectedDepart, selectedArrive, nb_paxCabComplete, nb_trajet);
// console.log("priceCab",priceCab);
        pricePax.cb = parseFloat(nbCab * parseFloat(priceCab.cb));
        pricePax.cash = parseFloat(nbCab * parseFloat(priceCab.cash));


        

        Object.assign(pricePax, {
            duree_aller: priceCab.duree_retour,
            duree_retour: priceCab.duree_aller,
            delai_arrive: priceCab.delai_depart,
            delai_depart: priceCab.delai_arrive,
            depart_type: priceCab.arrive_type,
            arrive_type: priceCab.depart_type,
            cp_arrive: priceCab.cp_depart,
            cp_depart: priceCab.cp_arrive,
        });





        if (nbPaxSup > 0) {
            const nb_paxCabSUp = {adults:nbPaxSup, children:0, babies:0, total:nbPaxSup};
            const priceCabSup = calculatePrivatePricesPax(privateData, selectedDepart, selectedArrive, nb_paxCabSUp, nb_trajet);

    // console.log("priceCabSup",priceCabSup);
            // Charge one more cab for remaining passengers
            pricePax.cb = parseFloat(pricePax.cb) + parseFloat(priceCabSup.cb);
            pricePax.cash = parseFloat(pricePax.cash) + parseFloat(priceCabSup.cash);
        }
    }

    pricePax.cb = parseFloat(pricePax.cb).toFixed(2);
    pricePax.cash = parseFloat(pricePax.cash).toFixed(2);
// console.log("pricePax",pricePax);
    return pricePax;
};
